import React from 'react'
import { observable } from 'mobx'
import * as defaultConst from '../../../constants/default_constants'
import * as linkConst from '../../../constants/link_constants'
import OmdbStoreInit from './omdb'
import Validators from '../validators'
import createSubentityConfs from './subentity'
import { BaseManipStateFn, BaseTableState } from '../base'

export default (store, origRecordId) => {
  const OmdbStore = OmdbStoreInit(store)
  const loadLanguageMetadata = (store, origRecordId) => {
    if (!origRecordId) {
      return false
    }
    store.cv.attrsState = 'loading'
    store.requester.call('/metadata/attributes/' + origRecordId, 'get')
      .then(result => {
        store.cv.attributes = result.data
        store.cv.attrsState = 'ready'
      })
      .catch(error => {
        store.cv.attrsState = error.message
        return store.onRequesterError(error)
      })
  }
  class ManipState extends BaseManipStateFn(store) {
    //
    init () {
      // only when updating !!!
      if (store && store.userLoggedIn && this.origRecordId) {
        store.modalEntityControl(false)
        // load infos about uploaded files
        store.requester.call(`/uploads/list/${this.origRecordId}`)
          .then(result => {
            store.cv.uploads = result.data
            store.checkState()
          })
          .catch(store.onRequesterError.bind(store))

        // languages list of all metadata
        loadLanguageMetadata(store, this.origRecordId)

        // pprolls report
        const parameters = { [defaultConst.PPROLLS_PARAMETER]: parseInt(this.origRecordId) }
        store.cv.sortstate = {}
        store.cv.itemsState = 'loading'
        store.requester.call(defaultConst.PPROLLS_REQUEST, 'post', { parameters })
          .then(result => {
            store.cv.items = result.data
            store.cv.itemsState = 'ready'
          })
          .catch(error => {
            store.cv.attrsState = error.message
            return store.onRequesterError(error)
          })
      }
      return super.init()
    }


    cancelValidity (rowId, s3Path) {
      const rowData = store.cv.uploads && store.cv.uploads.find(i => i.id === rowId)
      store.requester.call('/uploads/cancelValidity', 'post', { id: rowId })
          .then(result => {
            rowData.validity = null
            store.addMessage('Validity "inactive" has been canceled', 'success')
          })
          .catch(error => {
            store.cv.attrsState = error.message
            return store.onRequesterError(error)
          })
    }

    deleteAsset (rowId, s3Path) {
      const rowData = store.cv.uploads && store.cv.uploads.find(i => i.id === rowId)
      store.requester.call('/uploads/deleteAsset', 'post', { id: rowId, path: s3Path })
          .then(result => {
            rowData.state = 'deleted'
            store.addMessage('This asset was successfully deleted', 'success')
          })
          .catch(error => {
            store.cv.attrsState = error.message
            return store.onRequesterError(error)
          })
    }

    archiveAsset (rowId, s3Path) {
      const rowData = store.cv.uploads && store.cv.uploads.find(i => i.id === rowId)
      store.requester.call('/uploads/archiveAsset', 'post', { id: rowId, path: s3Path })
          .then(result => {
            rowData.state = 'archived'
            store.addMessage('This asset was successfully archived', 'success')
          })
          .catch(error => {
            store.cv.attrsState = error.message
            return store.onRequesterError(error)
          })
    }

    restoreAsset (rowId, s3Path) {
      const rowData = store.cv.uploads && store.cv.uploads.find(i => i.id === rowId)
      store.requester.call('/uploads/restoreAsset', 'post', { id: rowId, path: s3Path })
          .then(result => {
            rowData.state = 'encoded'
            store.addMessage('This asset was successfully restored', 'success')
          })
          .catch(error => {
            store.cv.attrsState = error.message
            return store.onRequesterError(error)
          })
    }

    requiredOptions = [
      'AmazonCategories',
      'Channels', // for YT table
      'ContractCurrency',
      'ContractItemStatus',
      'ContractTypes',
      'Countries', // for regions
      'Countries_alternative',
      'ExpenseTypes',
      'FilmCargoLanguages',
      'FilmCargoPlatforms',
      'FilmcargoFilmLabels',
      'FlyPrivatePlatforms',
      'FlyprivateCategories',
      'FormatCategory',
      'Genres',
      'Keywords',
      'Languages', // for YT table
      'MicrosoftContentType',
      'OriginalVersionLanguages',
      'Platforms',
      'PricingTiers',
      'RightsTypes',
      'Roles',
      'Tags',
      'TimeZones',
      'UploadTypes',
      'VideoId',
      'VodSaleTypes',
      ['episodes', '/films?attrs=["id", "title", "parent_id", "episode_no"]&filter={"video_type":"EPISODE"}', 'episode_no'],
      ['films_parent_id', '/films?attrs=["id", "parent_id"]'],
      ['persons', '/persons?attrs=["id", "name"]', 'name'],
      ['rating', '/rating?attrs=["id", "name", "description"]', 'name'],
      ['seasons', '/films?attrs=["id", "title", "parent_id", "season_no", "reverse_order"]&filter={"video_type":"SEASON"}', 'season_no'],
      linkConst.LOAD_OPTIONS.contracts,
      linkConst.LOAD_OPTIONS.countriesAlternative,
      linkConst.LOAD_OPTIONS.films,
      linkConst.LOAD_OPTIONS.flyprivate_all_pricings,
      linkConst.LOAD_OPTIONS.flyprivate_all_video_pricings,
      linkConst.LOAD_OPTIONS.flyprivate_pricings,
      linkConst.LOAD_OPTIONS.pprolls,
      linkConst.LOAD_OPTIONS.timeRestrictions,
      linkConst.LOAD_OPTIONS.timeZonesList
    ]

    onSaved (saved) {
      // update page title
      store.cv.edittitle = this._edittitle(saved, saved.title)

      store.markDirty('films')
      store.markDirty('films_parent_id')
      store.markDirty('seasons')
      store.markDirty('episodes')
      saved.reverseOrder = {}

      super.onSaved(saved)
    }



    _edittitle (entity, enTitle) {
      return (<span>
        {store.__(linkConst.LINK_FILMS_TITLE).concat(defaultConst.TITLE_DIVIDER)}
        <span className='text-primary text-strong one-line-title'>{enTitle}</span>
        <small className='badge label-default one-line-badge'>
          {entity.slug}
          {entity.slug && navigator.clipboard &&
            <i className='glyphicon glyphicon-copy copy-to-clipboard'
              onClick={() => { navigator.clipboard.writeText(entity.slug) }}
              title={store.__('Click to copy to the clipboard')} />}
        </small>
        {defaultConst.TITLE_DIVIDER}
        {store.__(defaultConst.TITLE_EDIT)}
      </span>)
    }
    _ensureArray (entity, attrname) {
      entity[attrname] = entity[attrname] === undefined ? [] : entity[attrname]
    }

    beforeSave (entity) {
      // trim all necesary values
      const trimNN = v => (v ? v.toString().trim() : null)
      entity.title = trimNN(entity.title)
      entity.attrs.forEach(a => { a.value = trimNN(a.value) })
      entity.attributes_regional.forEach(a => { a.value = trimNN(a.value) })

      // entity.title from entity.attrs.name
      const distTitleEN = entity.attrs.find(
        i => i.name === 'name' && i.lang === 'en' && i.platform === 'common'
      )
      if (!entity.title && distTitleEN && distTitleEN.value.length) {
        entity.title = distTitleEN.value
      }

      // reverse order
      const rOrder = entity.reverseOrder || {}
      if (rOrder && Object.keys(rOrder).length > 0) {
        entity.updated_at = new Date()
        Object.keys(rOrder).map(id => {
          if (!entity.id || parseInt(id) !== parseInt(entity.id)) {
            store.requester.call('/films/' + id, 'get')
              .then(({ data }) => {
                store.requester.call('/films/' + id, 'put', Object.assign({}, data, { updated_at: new Date(), reverse_order: rOrder[id] }))
              }).catch(store.onRequesterError.bind(this))
          }
        })
      }
      super.beforeSave(entity)
    }

    saveLanguages (langs = '') {
      console.log('it works!' + langs)
    }

    flagEditDone () {
      if (store.cv.record.has('id') && !store.cv.attrsState) {
        loadLanguageMetadata(store, store.cv.record.get('id'))
      }
      super.flagEditDone()
    }

    onLoaded (entity) {
      const id = entity.id
      if (!store.cv.attributes || store.cv.attributes.length <= 0) {
        loadLanguageMetadata(store, id)
      }
      // ensure all array attrs are present
      this._ensureArray(entity, 'attributes_regional')
      this._ensureArray(entity, 'attrs')
      this._ensureArray(entity, 'cats')
      this._ensureArray(entity, 'filmcargoFilmLabels')
      this._ensureArray(entity, 'flyprivate')
      this._ensureArray(entity, 'flyprivateCategories')
      this._ensureArray(entity, 'format')
      this._ensureArray(entity, 'keywords')
      this._ensureArray(entity, 'origcountries')
      this._ensureArray(entity, 'origlangs')
      this._ensureArray(entity, 'roles')
      entity.reverseOrder = {}
      // create title for edit view
      try {
        const enTitle = entity.attrs.find((i) => {
          return i.platform === 'common' && i.name === 'name' && i.lang === 'en'
        })
        store.cv.edittitle = this._edittitle(entity, enTitle && enTitle.value)
      } catch (e) {
        // title error
      }
      super.onLoaded(entity)
      this._createArrayMap(this.record)
    }

    prepareNew () {
      // NOTE: here all subentity arrays MUST be initialized
      this.record.set('flyprivateCategories', [])
      this.record.set('filmcargoFilmLabels', [])
      this.record.set('cats', [])
      this.record.set('keywords', [])
      this.record.set('attributes_regional', [])
      this.record.set('flyprivate', [])
      this.record.set('origlangs', [])
      this.record.set('origcountries', [])
      this.record.set('format', [])
      this.record.set('attrs', [])
      this.record.set('roles', [])
      this.record.set('youtubeinfo', [])
      this.record.set('youtube_asset_info', [])
      this.record.set('microsoftinfo', [])
      this.record.set('googleplayinfo', [])
      this.record.set('amazoninfo', [])
      this.record.set('itunesinfo', [])
      this.record.set('flyprivate_video_pricing', [])
      this.record.get('attrs').push({ platform: 'common', name: 'name', lang: 'en', value: '' })
      this.record.set('video_type', 'FILM')
      this.record.set('bundledFilms', [])
      this.record.set('platforms', '')
      this.record.set('reverseOrder', {})
    }

    _createArrayMap (entity) {
      entity.get('attrs').map((i) => {
        const key = `${i.platform}.${i.name}`
        this.arrayMap.set(key, i.value)
      })
    }

    createtitle = store.__(linkConst.LINK_FILMS_TITLE).concat(defaultConst.TITLE_DIVIDER) + store.__(defaultConst.TITLE_CREATE)
    @observable edittitle = store.__(linkConst.LINK_FILMS_TITLE).concat(defaultConst.TITLE_DIVIDER)
    @observable ytubePreviewSrc = ''
    @observable manip = new Map()
    @observable contractitems = []
    subentities = createSubentityConfs(store)
    omdb = new OmdbStore(this)
    @observable uploads = []
    @observable attributes = []
    @observable attrsState = null
    @observable items = []
    @observable itemsState = null
    @observable arrayMap = new Map()
    @observable previews = new Map()
    @observable temporary = new Map()
    @observable autoValues = { slug: true, name: true }
    selectedPlatform = 1
    validators = {
      slug: Validators.isMandatory(store),
      title: Validators.isMandatory(store),
      imdb_id: Validators.maxLength(store, 64),
      video_type: Validators.isMandatory(store),
      _global: (vals, errors) => {
        const id = vals.has('id') && vals.get('id')
        const parentId = vals.has('parent_id') && vals.get('parent_id')
        const slug = vals.has('slug') && vals.get('slug')
        const videoType = vals.has('video_type') && vals.get('video_type')

        // is name?
        const found = vals.get('attrs').find((i) => {
          return i.platform === 'common' && i.name === 'name' && i.lang === 'en'
        })
        if (!found || found.value.length === 0) {
          errors.set('common.name', store.__('At least english name is necessary.'))
        } else {
          errors.delete('common.name')
        }

        // slug control
        if (!id && slug && store.options.has('films') && store.options.get('films').find((i) => i.slug === slug)) {
          errors.set('slug', store.__('This "slug" is already in use.'))
        } else if (slug !== null && slug !== false && slug !== '') {
          errors.delete('slug')
        }

        // video_type validations
        if (id && ['FILM', 'EPISODE'].includes(videoType) && store.options.has('films_parent_id') && store.options.get('films_parent_id').find((i) => i.parent_id === id)) {
          errors.set('video_type', store.__('Please unassign all seasons or episodes from this item before setting this video type.'))
        } else if (['FILM', 'SERIES'].includes(videoType) && (vals.get('parent_id') || vals.get('season_no') || vals.get('episode_no'))) {
          errors.set('video_type', store.__('The film/series can not have: parent, season or episode number. Remove them before setting this video type.'))
        } else if (['SEASON'].includes(videoType) && vals.has('episode_no') && vals.get('episode_no')) {
          errors.set('video_type', store.__('The season can not have episode number. Remove it before setting this video type.'))
        } else if (['EPISODE'].includes(videoType) && vals.has('season_no') && vals.get('season_no')) {
          errors.set('video_type', store.__('The episode can not have season number. Remove it before setting this video type.'))
        } else if (id && ['SERIES'].includes(videoType) && store.options.has('episodes') && store.options.get('episodes').find((i) => i.parent_id === id)) {
          errors.set('video_type', store.__('Please unassign all episodes from this item before setting this video type.'))
        } else if (id && ['SEASON'].includes(videoType) && store.options.has('seasons') && store.options.get('seasons').find((i) => i.parent_id === id)) {
          errors.set('video_type', store.__('Please unassign all seasons from this item before setting this video type.'))
        } else {
          errors.delete('video_type')
        }

        // parent_id validations
        if (['SEASON', 'EPISODE'].includes(videoType) && (!vals.has('parent_id') || !vals.get('parent_id'))) {
          errors.set('parent_id', store.__('This is mandatory.'))
        } else if (parentId && ['SEASON'].includes(videoType) && store.options.has('films') && store.options.get('films') && store.options.get('films').length > 0 &&
          !store.options.get('films').find((i) => i.id === parentId && i.video_type === 'SERIES')) {
          errors.set('parent_id', store.__('Please choose valid parental series.'))
        } else if (parentId && ['EPISODE'].includes(videoType) && store.options.has('films') && store.options.get('films') && store.options.get('films').length > 0 &&
          !store.options.get('films').find((i) => i.id === parentId && i.video_type === 'SEASON')) {
          errors.set('parent_id', store.__('Please choose valid parental season.'))
        } else if (parentId && id && parentId === id) {
          errors.set('parent_id', store.__('You are trying to insert this record under itself. Please select another parent.'))
        } else {
          errors.delete('parent_id')
        }

        // season_no is mandatory
        if (['SEASON'].includes(videoType) && (!vals.has('season_no') ||
          vals.get('season_no') === null || vals.get('season_no') === '')) {
          errors.set('season_no', store.__('This is mandatory.'))
        } else {
          errors.delete('season_no')
        }

        // episode_no is mandatory
        if (['EPISODE'].includes(videoType) && (!vals.has('episode_no') ||
          vals.get('episode_no') === null || vals.get('episode_no') === '')) {
          errors.set('episode_no', store.__('This is mandatory.'))
        } else {
          errors.delete('episode_no')
        }
      }
    }
  }

  // --------------------------------------------------------------------------

  class TableState extends BaseTableState {
    attrs = [
      'id',
      'slug',
      'title',
      'imdb_id',
      'platforms',
      'video_type'
    ]

    headertitles = [
      store.__('ID'),
      store.__('slug'),
      store.__('title'),
      store.__('IMDB id'),
      store.__('platforms'),
      store.__('type')
    ]

    requiredOptions = [
      linkConst.LOAD_OPTIONS.contracts
    ]

    defaultSort = linkConst.DEFAULT_SORT[linkConst.LINK_FILMS]
    title = store.__(linkConst.LINK_FILMS_TITLE)
  }

  return { ManipState, TableState }
}
